import { useCallback } from "react";

import { createFiltersFromFilterData } from "../../../../utils/formViews";

import { Filter, ComplexFilter } from "../../../common/hooks/useLocalTable";
import useEntityFormViewTable from "../../../common/hooks/useEntityFormViewTable";

const getFilters = (searchString, filterData) => {
    const filters = [];

    if (searchString) {
        filters.push(new ComplexFilter(
            [
                new Filter("description", Filter.CO, searchString),
                new Filter("role", Filter.CO, searchString)
            ],
            ComplexFilter.OR
        ));
    }

    if (filterData) {
        const createdFilters = createFiltersFromFilterData(filterData);
        filters.push(...createdFilters);
    }

    return filters;
};

const useRolesTable = (roles) => {
    const getDialogFilters = useCallback(async ({ field, search="" }) => {
        const lowerSearch = search.toLowerCase();
        let keys;

        switch (field) {
            case "role": {
                keys = roles
                    .filter(({ role }) => (
                        role?.toLowerCase().includes(lowerSearch)
                    ))
                    .map(({ role }) => role);
                break;
            }
        }

        const uniqueKeys = [...new Set(keys)];
        const rows = uniqueKeys.map((key) => ({ key, text: key }));
        return { rows, total: rows?.length };
    }, [roles]);

    const viewTable = useEntityFormViewTable(roles, getFilters);

    return {
        ...viewTable,
        getDialogFilters
    };
};

export default useRolesTable;
